import { useEffect } from 'react'
import { Link, Navigate, useLocation } from 'react-router-dom'
import { Loader2, Lock } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import '../styles/dashboard.css'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, canAccessPage, revalidate, login } = useAuth()
  const location = useLocation()

  // Re-check the live Discord staff role as staff move around (throttled in
  // AuthContext), so a removed member loses access quickly.
  useEffect(() => { revalidate() }, [location.pathname, revalidate])

  if (loading) {
    return (
      <div className="dash min-h-screen flex items-center justify-center gap-3 text-[#8b8d94] text-[14px]">
        <Loader2 className="w-5 h-5 animate-spin" /> Checking your access
      </div>
    )
  }

  if (!isAuthenticated) {
    // Remember the deep link so staff land back on it after Discord sign-in
    // (it used to dump them on the public homepage).
    return <SignInGate onSignIn={login} />
  }

  if (!canAccessPage(location.pathname)) {
    return <AccessDenied />
  }

  return children
}

function SignInGate({ onSignIn }) {
  return (
    <div className="dash min-h-screen flex items-center justify-center p-6">
      <div className="dash-card max-w-sm w-full p-8 text-center dash-pop">
        <span className="mx-auto w-12 h-12 rounded-full bg-white/[0.06] flex items-center justify-center text-white mb-5"><Lock className="w-5 h-5" /></span>
        <h1 className="text-[20px] font-semibold text-white">Staff sign-in</h1>
        <p className="mt-2 text-[14px] text-[#8b8d94]">Sign in with the Discord account that has your staff role.</p>
        <button onClick={onSignIn} className="dash-btn dash-btn-primary w-full mt-6">Continue with Discord</button>
        <Link to="/" className="block mt-4 text-[13px] text-[#8b8d94] hover:text-white">Back to the website</Link>
      </div>
    </div>
  )
}

export function AccessDenied() {
  return (
    <div className="dash min-h-[70vh] flex items-center justify-center p-6">
      <div className="dash-card max-w-md w-full p-8 text-center dash-pop">
        <span className="mx-auto w-12 h-12 rounded-full bg-[#e5233b]/15 text-[#ff6b7d] flex items-center justify-center mb-5"><Lock className="w-5 h-5" /></span>
        <h1 className="text-[20px] font-semibold text-white">You don't have access to this page</h1>
        <p className="mt-2 text-[14px] text-[#8b8d94]">Your rank can't open this section. If you think that's wrong, ask a Manager to check your Discord roles.</p>
        <Link to="/staff" className="dash-btn dash-btn-primary mt-6">Back to dashboard</Link>
      </div>
    </div>
  )
}

export default ProtectedRoute
